export class DiscussionListConfig {
  type: string = "AllDiscussionsLatestFeed";
  filters: {
    term?: string;
    tag?: string;
    author?: string;
    community?: string;
    votedBy?: string;
    sortBy?: string;
    limit?: number;
    offset?: number;
  } = {};
}
